import { IApi } from "./IApi";

import axios, { AxiosResponse } from "axios";
import { AuthenticationMemo } from "../../core/AuthenticationMemo/AuthenticationMemo";

const prodUrl = "https://api.showmusicbrasil.com/";
const localUrl = "http://localhost:3333";

const currentUrl = window.location.href;
const local =
  currentUrl.search(/localhost/i) > -1 || currentUrl.search("127.0.0") > -1;

const baseUrl = local ? localUrl : prodUrl;

const requisition = axios.create({
  baseURL: baseUrl,
});

requisition.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = `Bearer ${localStorage.getItem(
      "@showmusic:token",
    )}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

requisition.interceptors.response.use(
  (response) => {
    return Promise.resolve(response);
  },
  (error) => {
    if (
      error.response.status === 401 &&
      error.response.data.message === "Invalid JWT token."
    ) {
      AuthenticationMemo.SignOut();
      window.location.reload();
    }
    return Promise.reject(error);
  },
);

export default class Api implements IApi {
  static async get(route: string): Promise<AxiosResponse> {
    return await requisition.get(route);
  }

  static async post(route: string, requestData: any): Promise<AxiosResponse> {
    return await requisition.post(route, requestData);
  }

  static async postFile(
    route: string,
    requestData: any,
  ): Promise<AxiosResponse> {
    return await requisition.post(route, requestData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  static async put(route: string, requestData: any): Promise<AxiosResponse> {
    return await requisition.put(route, requestData);
  }

  static async delete(route: string): Promise<AxiosResponse> {
    return await requisition.delete(route);
  }

  responseSucces: AxiosResponse | null;
  responseError: AxiosResponse | null;

  constructor() {
    this.responseSucces = null;
    this.responseError = null;
  }

  getStatusSuccess(): number | undefined {
    return this.responseSucces?.status;
  }

  getStatusError(): number | undefined {
    return this.responseError?.status;
  }

  getData(): any {
    return this.responseSucces?.data;
  }
}
